import {
  WSAvatar,
  WSElementProps,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

type Props = WSElementProps;

export const WalletPending: React.FC<Props> = ({
  className,
  ...elementProps
}) => (
  <WSFlexBox
    wrap="nowrap"
    alignItems="center"
    className={classNames(className, styles.wrapper)}
    {...elementProps}
  >
    <WSAvatar.Icon
      color="white"
      colorBackground="garnet"
      icon="wallet"
      mr="M"
    />

    <WSText weight="medium">Wingspan Wallet</WSText>
  </WSFlexBox>
);
